import { Box, MenuItem, Select, Typography } from "@mui/material";
import React from "react";

const DateGrouping = ({
  dateGroupings,
  selectedDateGrouping,
  setDateGrouping,
}) => {
  const handleSetGrouping = (e) => {
    setDateGrouping(e.target.value);
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Typography variant="h5">Date Grouping</Typography>
      </Box>
      <Box sx={{ marginTop: 2 }}>
        {/* <Button variant="contained" sx={{ marginRight: 1, borderRadius: 2 }}>
          Product Library
        </Button> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            height: "72px",
            width: "35%",
            borderRadius: 2,
            backgroundColor: (theme) => theme.palette.terrain[200],
            border: "1px solid",
            borderColor: (theme) => theme.palette.terrain[300],
            padding: 2,
            marginTop: 2,
          }}
        >
          <Select
            value={selectedDateGrouping}
            onChange={handleSetGrouping}
            sx={{
              width: "100%",
              height: "40px",
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
          >
            {dateGroupings.map((x) => (
              <MenuItem value={x.value} key={x.value}>
                {x.key}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
    </Box>
  );
};

export default DateGrouping;
